<template>
  <div class="disclaimer-checkout">
    <div class="disclaimer-checkout__disclaimer">
      <vb-checkbox
        v-model="check_disclaimer"
        :vb_options="{
          type: 'light', 
          size: 'lg',
          text: 'Ho preso visione delle indicazioni di sicurezza e delle normative doganali e sanitarie di accesso a questa destinazione sul sito <a href=\'https://www.viaggiaresicuri.it\' target=\'_blank\'>Viaggiare sicuri</a> del Ministero degli esteri italiano.',
        }"
      />
    </div>

    <div
      v-if="invalid || !check_disclaimer"
      class="disclaimer-checkout__errors"
    >
      <div v-if="invalid">Compila tutti i campi obbligatori per proseguire</div>
      <template v-if="invalid">
        <div v-for="(field_errors, field_name) in errors" :key="field_name">
          <span v-for="(err, err_index) in field_errors" :key="err_index">{{
            err
          }}</span>
        </div>
      </template>
      <div v-if="!check_disclaimer">Accetta le condizioni per proseguire</div>
    </div>

    <div class="disclaimer-checkout__action">
      <vb-button
        :vb_options="{
          disabled: invalid || !check_disclaimer,
          variant: 'info',
          to: { name: 'checkout' },
          icon_disabled: 'lock',
          text: 'Vai al Checkout',
        }"
        @click="$emit('checkout')"
      >
      </vb-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "disclaimer-checkout",
  props: {
    invalid: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      check_disclaimer: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.disclaimer-checkout {
  margin-top: $grid-gutter-width;

  @include media-breakpoint-up(md) {
    margin-top: $grid-gutter-width * 2;
  }

  &__disclaimer { 
    max-width: 66.66%;
    margin-left: auto;
    margin-right: auto;
    
    ::v-deep .vb-check__title {
      line-height: normal;
      overflow: hidden;
      font-size: $font-size-lg;
    }

    ::v-deep .vb-check {
      margin-bottom: $grid-gutter-width; 
      &:last-child {
        margin-bottom: $grid-gutter-width * 2;
      }
    }
  }

  &__errors {
    text-align: right;
    color: $danger;
    margin-bottom: 0.5rem;
    font-size: 0.85rem;
  }

  &__action {
    display: flex;
    justify-content: center;

    @include media-breakpoint-up(lg) {
      justify-content: flex-end;
    }
  }
}
</style>
